import { themeQuartz, iconSetQuartzLight } from "ag-grid-community";

/** Default project board grid (light). */
export const boardAgGridThemeLight = themeQuartz.withPart(iconSetQuartzLight).withParams({
  backgroundColor: "#fafafa",
  fontFamily: "Roboto, Arial, sans-serif",
  fontSize: 12,
  headerBackgroundColor: "#f9fafb",
  headerFontWeight: 500,
  foregroundColor: "#374151",
  spacing: 4,
  browserColorScheme: "light",
});

/** Rare twilight deck — refined indigo dark grid. */
export const boardAgGridThemeTwilight = themeQuartz.withPart(iconSetQuartzLight).withParams({
  browserColorScheme: "dark",
  backgroundColor: "#161b28",
  headerBackgroundColor: "#222a3f",
  headerTextColor: "#e8ecf4",
  foregroundColor: "#cbd5e1",
  borderColor: "#3d4a66",
  oddRowBackgroundColor: "#131825",
  rowHoverColor: "rgba(124, 140, 255, 0.12)",
  selectedRowBackgroundColor: "rgba(124, 140, 255, 0.2)",
  chromeBackgroundColor: "#1a2035",
  fontFamily: '"Segoe UI", ui-sans-serif, system-ui, Roboto, sans-serif',
  fontSize: 12,
  spacing: 4,
});

/** Rare copper hearth — warm dark grid. */
export const boardAgGridThemeCopper = themeQuartz.withPart(iconSetQuartzLight).withParams({
  browserColorScheme: "dark",
  backgroundColor: "#1f1814",
  headerBackgroundColor: "#2d231c",
  headerTextColor: "#f5ebe0",
  foregroundColor: "#d6c4b0",
  borderColor: "#5c4033",
  oddRowBackgroundColor: "#1a1410",
  rowHoverColor: "rgba(217, 119, 6, 0.12)",
  selectedRowBackgroundColor: "rgba(217, 119, 6, 0.18)",
  chromeBackgroundColor: "#261e18",
  fontFamily: 'Georgia, "Times New Roman", serif',
  fontSize: 12,
  spacing: 4,
});

/** Legendary pixel arcade — dark grid aligned to theme shell. */
export const boardAgGridThemePixel = themeQuartz.withPart(iconSetQuartzLight).withParams({
  browserColorScheme: "dark",
  backgroundColor: "#2b2d42",
  headerBackgroundColor: "#3d405b",
  headerTextColor: "#edf2f4",
  foregroundColor: "#e2e8f0",
  borderColor: "#475569",
  oddRowBackgroundColor: "#252538",
  rowHoverColor: "rgba(132, 204, 22, 0.12)",
  selectedRowBackgroundColor: "rgba(132, 204, 22, 0.2)",
  chromeBackgroundColor: "#252538",
  fontFamily: 'ui-monospace, "Cascadia Code", Menlo, Consolas, monospace',
  fontSize: 12,
  spacing: 4,
});

/** Legendary neon district — cyberpunk dark grid. */
export const boardAgGridThemeNeon = themeQuartz.withPart(iconSetQuartzLight).withParams({
  browserColorScheme: "dark",
  backgroundColor: "#0f1419",
  headerBackgroundColor: "#1a2234",
  headerTextColor: "#e2e8f0",
  foregroundColor: "#cbd5e1",
  borderColor: "#334155",
  oddRowBackgroundColor: "#121826",
  rowHoverColor: "rgba(6, 182, 212, 0.14)",
  selectedRowBackgroundColor: "rgba(236, 72, 153, 0.18)",
  chromeBackgroundColor: "#121826",
  fontFamily: '"Segoe UI", ui-sans-serif, system-ui, Roboto, sans-serif',
  fontSize: 12,
  spacing: 4,
});

/** Rare emerald vault. */
export const boardAgGridThemeEmerald = themeQuartz.withPart(iconSetQuartzLight).withParams({
  browserColorScheme: "dark",
  backgroundColor: "#101c16",
  headerBackgroundColor: "#1a3026",
  headerTextColor: "#e8f5ef",
  foregroundColor: "#c5ddd0",
  borderColor: "#2a4a3a",
  oddRowBackgroundColor: "#0c1612",
  rowHoverColor: "rgba(52, 211, 153, 0.12)",
  selectedRowBackgroundColor: "rgba(52, 211, 153, 0.2)",
  chromeBackgroundColor: "#14241c",
  fontFamily: '"Segoe UI", ui-sans-serif, system-ui, Roboto, sans-serif',
  fontSize: 12,
  spacing: 4,
});

/** Rare obsidian gold. */
export const boardAgGridThemeObsidian = themeQuartz.withPart(iconSetQuartzLight).withParams({
  browserColorScheme: "dark",
  backgroundColor: "#101014",
  headerBackgroundColor: "#1f1f27",
  headerTextColor: "#f5f5f4",
  foregroundColor: "#d6d3d1",
  borderColor: "#3f3f46",
  oddRowBackgroundColor: "#0b0b0d",
  rowHoverColor: "rgba(234, 179, 8, 0.12)",
  selectedRowBackgroundColor: "rgba(234, 179, 8, 0.18)",
  chromeBackgroundColor: "#17171c",
  fontFamily: 'Georgia, "Times New Roman", serif',
  fontSize: 12,
  spacing: 4,
});

/** Rare aurora fjord. */
export const boardAgGridThemeAurora = themeQuartz.withPart(iconSetQuartzLight).withParams({
  browserColorScheme: "dark",
  backgroundColor: "#0a1a20",
  headerBackgroundColor: "#12333d",
  headerTextColor: "#e6f7f5",
  foregroundColor: "#c5dde0",
  borderColor: "#1e4d5a",
  oddRowBackgroundColor: "#07151a",
  rowHoverColor: "rgba(45, 212, 191, 0.12)",
  selectedRowBackgroundColor: "rgba(45, 212, 191, 0.2)",
  chromeBackgroundColor: "#0d242c",
  fontFamily: '"Segoe UI", ui-sans-serif, system-ui, Roboto, sans-serif',
  fontSize: 12,
  spacing: 4,
});

/** Legendary solar flare. */
export const boardAgGridThemeSolar = themeQuartz.withPart(iconSetQuartzLight).withParams({
  browserColorScheme: "dark",
  backgroundColor: "#1f0e08",
  headerBackgroundColor: "#3b1a0c",
  headerTextColor: "#fff7ed",
  foregroundColor: "#fed7aa",
  borderColor: "#7c2d12",
  oddRowBackgroundColor: "#1a0a06",
  rowHoverColor: "rgba(249, 115, 22, 0.14)",
  selectedRowBackgroundColor: "rgba(220, 38, 38, 0.18)",
  chromeBackgroundColor: "#2a1208",
  fontFamily: 'Georgia, "Times New Roman", serif',
  fontSize: 12,
  spacing: 4,
});

/** Legendary void orchid. */
export const boardAgGridThemeOrchid = themeQuartz.withPart(iconSetQuartzLight).withParams({
  browserColorScheme: "dark",
  backgroundColor: "#120818",
  headerBackgroundColor: "#241436",
  headerTextColor: "#f5e9ff",
  foregroundColor: "#e9d5ff",
  borderColor: "#4c1d6a",
  oddRowBackgroundColor: "#0c0614",
  rowHoverColor: "rgba(192, 38, 211, 0.14)",
  selectedRowBackgroundColor: "rgba(99, 102, 241, 0.18)",
  chromeBackgroundColor: "#1a0f28",
  fontFamily: '"Segoe UI", ui-sans-serif, system-ui, Roboto, sans-serif',
  fontSize: 12,
  spacing: 4,
});

/** Legendary glacier pulse. */
export const boardAgGridThemeGlacier = themeQuartz.withPart(iconSetQuartzLight).withParams({
  browserColorScheme: "dark",
  backgroundColor: "#081722",
  headerBackgroundColor: "#123246",
  headerTextColor: "#e0f2fe",
  foregroundColor: "#bae6fd",
  borderColor: "#1e5a75",
  oddRowBackgroundColor: "#061018",
  rowHoverColor: "rgba(56, 189, 248, 0.14)",
  selectedRowBackgroundColor: "rgba(125, 211, 252, 0.18)",
  chromeBackgroundColor: "#0c1e2c",
  fontFamily: '"Segoe UI", ui-sans-serif, system-ui, Roboto, sans-serif',
  fontSize: 12,
  spacing: 4,
});

const THEME_CLASS_TO_GRID = {
  "pb-board-theme-twilight-deck": boardAgGridThemeTwilight,
  "pb-board-theme-copper-hearth": boardAgGridThemeCopper,
  "pb-board-theme-emerald-vault": boardAgGridThemeEmerald,
  "pb-board-theme-obsidian-gold": boardAgGridThemeObsidian,
  "pb-board-theme-aurora-fjord": boardAgGridThemeAurora,
  "pb-board-theme-pixel-arcade": boardAgGridThemePixel,
  "pb-board-theme-neon-district": boardAgGridThemeNeon,
  "pb-board-theme-solar-flare": boardAgGridThemeSolar,
  "pb-board-theme-void-orchid": boardAgGridThemeOrchid,
  "pb-board-theme-glacier-pulse": boardAgGridThemeGlacier,
};

export function boardAgGridThemeForClass(themeClass) {
  if (themeClass && THEME_CLASS_TO_GRID[themeClass]) {
    return THEME_CLASS_TO_GRID[themeClass];
  }
  return boardAgGridThemeLight;
}
